import { Routes, Route } from 'react-router-dom';
import Sidebar from './Sidebar';
import AboutOverview from '../pages/about/Overview';
import AboutHistory from '../pages/about/History';
import AboutOrg from '../pages/about/Organization';
import AboutPhilosophy from '../pages/about/Philosophy';
import AboutBusiness from '../pages/about/Business';
import AboutTech from '../pages/about/Technology';
import SrvHeatControl from '../pages/services/HeatControl';
import SrvSFControl from '../pages/services/SmartFarm';
import SrvPSI5 from '../pages/services/PSI5Intrface';
import SrvVMPB from '../pages/services/PhotoboothIO';
import SrvHANESS from '../pages/services/HanessTester';
import SrvMOTORTESTER from '../pages/services/MotorTester';
import './SectionLayout.css'; // 추가

function SectionLayout({ section }) {
    return (
      <div>
        {/* ✅ 사이드바 추가 (fixed 구조에 맞춰 위치 유지) */}
        <Sidebar section={section} />
        <div className="section-content">
        <Routes>
          {section === 'about' && (
            <>
                <Route path="/" element={<AboutOverview />} />
                <Route path="history" element={<AboutHistory />} />
                <Route path="organization" element={<AboutOrg />} />
                <Route path="philosophy" element={<AboutPhilosophy />} />
                <Route path="business" element={<AboutBusiness />} />
                <Route path="technology" element={<AboutTech />} />
            </>
          )}
          {section === 'services' && (
            <>
              <Route path="/" element={<SrvHeatControl />} />
              <Route path="smartfarm" element={<SrvSFControl />} />
              <Route path="psi5interface" element={<SrvPSI5 />} />
              <Route path="photoboothIO" element={<SrvVMPB />} />
              <Route path="hanesstester" element={<SrvHANESS />} />
              <Route path="motortester" element={<SrvMOTORTESTER />} />
            </>
          )}
        </Routes>
      </div>
    </div>
  );
}

export default SectionLayout;
